import { Address } from "@/types/quoteTypes"
import React, { createContext, useContext } from "react"
import { useLocalStorage } from "@/hooks/useLocalStorage"
import { FormAnswers } from "@/types/formConfig"

type UserContextType = {
  addresses: Address[]
  setAddresses: (addresses: Address[]) => void
  selectedAddress: Address | null
  setSelectedAddress: (address: Address | null) => void
  showAddresses: boolean
  setShowAddresses: (show: boolean) => void
  answers: FormAnswers | null
  setAnswers: (answers: FormAnswers | null) => void
  currentQuestionIndex: number
  setCurrentQuestionIndex: (index: number) => void
  validationError: string | null
  setValidationError: (error: string | null) => void
}

const UserContext = createContext<UserContextType | null>(null)

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [addresses, setAddresses] = useLocalStorage<Address[]>('addresses', [])
  const [selectedAddress, setSelectedAddress] = useLocalStorage<Address | null>('selectedAddress', null)
  const [showAddresses, setShowAddresses] = useLocalStorage<boolean>('showAddresses', false)
  const [answers, setAnswers] = useLocalStorage<FormAnswers | null>('answers', null)
  const [currentQuestionIndex, setCurrentQuestionIndex] = useLocalStorage<number>('currentQuestionIndex', 0)
  const [validationError, setValidationError] = useLocalStorage<string | null>('validationError', null)

  return (
    <UserContext.Provider value={{
        addresses, setAddresses,
        selectedAddress, setSelectedAddress,
        showAddresses, setShowAddresses,
        answers, setAnswers,
        currentQuestionIndex, setCurrentQuestionIndex,
        validationError, setValidationError
      }}>
      {children}
    </UserContext.Provider>
  )
}

export const useUserContext = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider")
  }
  return context
}